import React from 'react';
import SharedChatSidebar from '../../PageClientChat/Components/ChatSidebar';
import { Chat } from '../types/Chat';

interface ChatSidebarProps {
  chats: Chat[];
  handleShowChat: () => void;
}

const ChatSidebar: React.FC<ChatSidebarProps> = (props) => {
  return (
    <SharedChatSidebar
      chats={props.chats as any}
      handleShowChat={props.handleShowChat}
      mapChatToPreview={(chat: any) => ({
        name: chat.client_name,
        uuid: chat.client_uuid,
        avatar: chat.client_avatar,
      })}
      fallbackPreviewText="Ha prenotato da te"
      showPrivacyNotice={false}
    />
  );
};

export default ChatSidebar;
